module.exports = __webpack_public_path__ + "f744b26e9479734e424f739740307798.svg";